import { useContext } from 'react';
import ScrollContext from '../contexts/ScrollContext/ScrollContext';

export const useScrollContext = () => {
  return useContext(ScrollContext);
};
